###
  Creative Moderation crud widget
###

class INTENT.widgets.CreativeModeration extends INTENT.widgets.CreativeViewer

  screen_lock: () =>
    null

  screen_unlock: () =>
    null

  popup_display: () =>
    reason = @reason
    reason_text_ru = @reason_text_ru
    reason_text_en = @reason_text_en

    console.log reason_text_ru, reason_text_en

    url = "/ajax/get_moderation_modal?id=#{@get_creative_id()}"
    if reason
      url = url + "&reason=#{reason}"

    if reason_text_ru
      url = url + "&reason_text_ru=#{reason_text_ru}"

    if reason_text_en
      url = url + "&reason_text_en=#{reason_text_en}"

    request = $.ajax({
      url: url,
      type: "get",
      dataType: "html"
    });

    request.done (data) =>
      @show_modal(data)
      super()


  @MODAL: "#modal_moderation"

  @VAST_INFO_API: "/ajax/vast_info"

  @ATTR_NAME: "data-widget-creative-moderation"
  @ATTR_REASON: "#{@ATTR_NAME}-reason"
  @ATTR_REASON_TEXT_RU: "#{@ATTR_REASON}-text-ru"
  @ATTR_REASON_TEXT_EN: "#{@ATTR_REASON}-text-en"
  @ATTR_NAME_FORM: "#{@ATTR_NAME}-form"
  @ATTR_ONCE_CLICK: "#{@ATTR_NAME}-one-click"
  @ATTR_SHOW: "#{@ATTR_NAME}-show"

  @RECHECK_SSP_FORM: '#recheck_ssp'

  constructor: (@el) ->
    @s = @.constructor

    @el.on "submit", "form", @submit_row

    @canSubmit = false;
    $(@s.RECHECK_SSP_FORM).on 'submit', (e) =>
      @recheck_ssp(e)

    super(@el)

  preview_from_self: (self) =>
    @uncollapse = 1 * self.attr INTENT.widgets.CreativeModeration.ATTR_SHOW
    @reason = self.attr @s.ATTR_REASON
    @reason_text_ru = self.attr @s.ATTR_REASON_TEXT_RU
    @reason_text_en = self.attr @s.ATTR_REASON_TEXT_EN
    super(self)

  submit_row: (e) =>
    self = @
    form = $(e.currentTarget)

    request = $.ajax({
      url: form.attr("action"),
      type: form.attr("method"),
      data: form.serialize(),
      dataType: "json"
    });

    request.done (xhr) ->
      self.success_submit_row(form, xhr)

    return false

  success_submit_row: (form, xhr) =>
    id = @get_creative_id()

    init_creative_content_tags('select[name="content_tags\\[\\]"]')
    $('select[name="content_tags\\[\\]"]').select2 'val', xhr.fields.content_tags

    $('.creative-moderation-buttons').find("[data-widget-creative-moderation-reason][data-preview-creative=" + id + "]").removeClass 'active'
    $('.creative-moderation-buttons').find("[data-widget-creative-moderation-reason][data-preview-creative=" + id + "]").each ->
      self = $ @
      if xhr.fields.moderation_status == self.attr('data-widget-creative-moderation-reason')
        self.addClass 'active'

    $('#creative-statuses-info').replaceWith(xhr.html_line_statuses)
    $("[data-creative-moderation-status='#{xhr.id}']").html(xhr.fields.moderation_status_text)
    if (xhr.fields.moderation_status != 'REJECTED')
      $("[data-creative-moderation-status='#{xhr.id}']").removeClass('dotted')
    @popup_close()

  popup_close: () =>
    @modal.modal('hide')
    super();

  init_handlers: ->
    init_radio_block()
    $('select.select2-init').select2 {minimumResultsForSearch: -1}
    $(document).one 'init-global-scope', () =>
      init_creative_content_tags('select[name="content_tags\\[\\]"]')

  update_view: (status = null) ->
    elements = @modal.find "[data-show-on]"
    elements.addClass 'hide'
    status_value = status.val()
    elements.each ->
      el = $ @
      if el.attr('data-show-on') == status_value
        el.removeClass 'hide'

  prepare_view: ->
    status = @modal.find "[data-status]"
    @update_view status
    @timer = setInterval =>
      @update_view status
    , 100

  show_modal: (data) ->
    clearInterval @timer
    unless @modal then @modal = $ INTENT.widgets.CreativeModeration.MODAL
    form = @modal.find('[' + INTENT.widgets.CreativeModeration.ATTR_NAME_FORM + ']')
    form.html data
    if (@uncollapse)
      form.find('.accordion-body').addClass('in')
    @modal.modal()
    @init_handlers()
    @prepare_view()

  recheck_ssp: (e) ->
    instance = @
    unless instance.canSubmit
      el = $(e.target)

      submitAction = (val) ->
        instance.canSubmit = true;
        el.find("[name='renew_revision']").val(val);
        el.submit()

      show_confirm(
        __('recheck_ssp.confirmation')
        () ->
          submitAction 1
        () ->
          submitAction 0
        __('btn.yes')
        __('btn.no')
      )
      return false;
    return true
